import { BACKEND_APP_URL } from "app/utils/constants/paths";
import jwtAxios from "axios";
const jwtAuthAxios = jwtAxios.create({
    
    baseURL: BACKEND_APP_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

jwtAuthAxios.interceptors.response.use(
    res => res,
    err => {
        if(err.response && err.response.data.type === "token-invalid") {
            //todo logout the user
        }
        return Promise.reject(err);
    }
);

export const setAuthToken = (data) => {
    if(data) {
        jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + data.token;
        jwtAuthAxios.defaults.headers.common['Ccode'] = data?.currentBranch?.FL_COMPANY_CODE;
        jwtAuthAxios.defaults.headers.common['Finyear'] = data.FINYEAR;
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data));
    } else {
        delete jwtAuthAxios.defaults.headers.common['Authorization'];
        delete jwtAuthAxios.defaults.headers.common['Ccode'];
        delete jwtAuthAxios.defaults.headers.common['Finyear'];
        localStorage.removeItem('token');
        localStorage.removeItem('user');
    }
};

// export const getAuthToken = () => {
//     return localStorage.getItem("token");
// };

//todo: define interceptors and other configuration like baseURL, headers etc. here
export default jwtAuthAxios;